<template>
  <b-container fluid>
     <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-chart-column" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary"  @click="gpath_career_interAdd">{{cvbtnAddNew}}>{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
        <b-col lg="10" xl="10">
          <b-row>
            <b-col class="col-12 mb-3">
              <b-form-input
                id="search"
                v-model="filter"
                type="search"
                :placeholder="cvSearchText"></b-form-input>
              </b-col>
              <!-- GPath Producat Id -->
              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.pdt_id" class="form-control" title="session states" @change="setPdtId">
                  <option v-for="item in gpcPdtIdList" :key="item.id" :value="item.id" >
                    {{ item.id }}
                  </option>
                </select>
              </b-col><!-- GPath Producat Id -->
            </b-row>
          </b-col>
          <b-col class="col-12 col-sm-12 col-md-12 col-lg-2 mb-3">
            <div v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'">
              <VueJsonToCsv :json-data="gpath_career_interObjList" csv-title="gpath_career_interest" v-if="gpath_career_interObjList && gpath_career_interObjList.length">
                <i class="fa-solid fa-file-csv Download_button"></i>
              </VueJsonToCsv>
              <CsvDownload :propModuleFile="cvModuleFile" class="Download_button" />
              <CsvUpload :propModulePrefix="cvModulePrefix" class=" Download_button"  />
            </div>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="gpath_career_interObjList && gpath_career_interObjList.length > 0">
            <b-table
              hover
              responsive
              :items="gpath_career_interObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
            <template v-slot:cell(image)="data">
              <img :src="data.item.image" style="background-color: #e52e2c; width: 50px; height: 50px;">
            </template>
            <template v-slot:cell(name)="data">
              {{data.item.name}}<br>
              <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" size="sm" @click="gpath_career_interEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0"></i></b-button>
              <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="showGPathCareerInterDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0"></i></b-button>
              <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 pt-1 btn-secondary btn-sm" title="View GPaths Career Attribute List" @click="gpath_career_attri_list(data.item)"><i class="fa fa-list" aria-hidden="true"></i></b-button>
            </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="7" md="8" class="my-1">
            <b-col sm="12" md="7">
              <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
            </b-col>
          </b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelGPathCareerInterAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xl"
    >
      <GPathCareerInterAdd :propOpenedInModal="true" @emitCloseGPathCareerInterAddModal="closeGPathCareerInterAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_career_interAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareerInterAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelGPathCareerInterEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xl"
    >
      <GPathCareerInterEdit :propOpenedInModal="true" :propGPathCareerInterObj="gpath_career_interEditObj" @emitCloseGPathCareerInterEditModal="closeGPathCareerInterEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_career_interEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareerInterEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelGPathCareerInterDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelGPathCareerInterDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="gpath_career_interDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { GPathCareerInters } from "../../../FackApi/api/GPathCareerInter"
import GPathCareerInterAdd from "./GPathCareerInterAdd"
import GPathCareerInterEdit from "./GPathCareerInterEdit"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"
import CsvUpload from "../../../components/Csv/CsvUpload.vue"
import CsvDownload from "../../../components/Csv/CsvDownload.vue"
import { GPathConfig } from "../../../FackApi/api/GpathConfig"

export default {
  name: "GPathCareerInterList",
  components: {
    GPathCareerInterAdd,
    GPathCareerInterEdit,
    CsvUpload,
    CsvDownload
  },
  data () {
    return {
      apiName: "gpath_careers_inter_list",
      cvModuleFile: "gpath_careers_inter_list",
      cvModulePrefix: "GPI",
      cvCardTitle: "GPath Career Combo",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit GPath Career Combo",
      cvAddModalHeader: "Add GPath Career Combo",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPathCareerInter List Response",
      showModelGPathCareerInterAdd: false,
      showModelGPathCareerInterEdit: false,
      showModelGPathCareerInterDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "name", key: "name", class: "text-left align-text-top", sortable: true },
        { label: "Product Id", key: "pdt_id", class: "text-left align-text-top text-break w-100px", sortable: true },
        { label: "title1", key: "title1", class: "text-left align-text-top", sortable: true },
        { label: "title2", key: "title2", class: "text-left align-text-top", sortable: true }
      ],
      gpath_career_interObjList: null,
      gpath_career_interEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentBatchNo: 1,
      dataPerPage: 10,
      delObj: null,
      whereFilter: {
        isAdminPanel: true,
        pdt_id: ""
      },
      gpcPdtIdList: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    this.gpath_career_interList()
    this.gpathsproductIdListGet()
  },
  methods: {
    /**
     * Calling SetPdtId into filter
    */
    async setPdtId () {
      this.gpath_career_interList()
    },
    /**
     * Calling Function as per whereFilter
    */
    async getgpath_career_interDateWise () {
      this.gpath_career_interList()
    },
    /**
     * gpath_career_list
     */
    gpath_career_attri_list (career) {
      this.$router.push(`/gpath_career_type_list/${career.name}`)
    },
    /**
      * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.gpath_career_interList(true)
    },
    /**
     * gpath_career_interList
     */
    async gpath_career_interList (loadViaLoadMore = false) {
      try {
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage

        let gpathCareerInterListResp = await GPathCareerInters.gpath_career_interList(this, this.whereFilter)
        if (gpathCareerInterListResp.resp_status) {
          if (!loadViaLoadMore) {
            this.gpath_career_interObjList = [ ...gpathCareerInterListResp.resp_data.data ]
          }
          else {
            this.gpath_career_interObjList = [ ...this.gpath_career_interObjList, ...gpathCareerInterListResp.resp_data.data ]
          }
          this.gpath_career_interObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.gpath_career_interObjList.length
        }
        else {
          this.toastMsg = gpathCareerInterListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at gpath_career_interList() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_interAdd
     */
    gpath_career_interAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_career_inter_add")
        }
        else {
          this.showModelGPathCareerInterAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_interAdd() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_interEdit
     */
    gpath_career_interEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_career_inter_edit/" + this.gpath_career_interEditObj.gpci_id)
        }
        else {
          this.gpath_career_interEditObj = item
          this.showModelGPathCareerInterEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_interEdit() and Exception:", err.message)
      }
    },
    /**
     * showGPathCareerInterDeleteDialog
     */
    showGPathCareerInterDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelGPathCareerInterDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showGPathCareerInterDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_interDelete
     */
    async gpath_career_interDelete () {
      try {
        let gpathCareerInterDelResp = await GPathCareerInters.gpath_career_interDelete(this, this.delObj.gpci_id)
        await ApiResponse.responseMessageDisplay(this, gpathCareerInterDelResp)

        if (gpathCareerInterDelResp && !gpathCareerInterDelResp) {
          this.showModelGPathCareerInterDelete = false
          return false
        }

        let index = this.gpath_career_interObjList.indexOf(this.delObj)
        this.gpath_career_interObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelGPathCareerInterDelete = false
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_interDelete() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareerInterAddModal
     */
    closeGPathCareerInterAddModal (gpathCareerInterAddData) {
      try {
        if (gpathCareerInterAddData) {
          if (this.gpath_career_interObjList && this.gpath_career_interObjList.length >= 1) {
            let gpathCareerInterObjLength = this.gpath_career_interObjList.length
            let lastId = this.gpath_career_interObjList[gpathCareerInterObjLength - 1]["id"]
            gpathCareerInterAddData.id = lastId + 1
          }
          else {
            this.gpath_career_interObjList = []
            gpathCareerInterAddData.id = 11111
          }

          gpathCareerInterAddData.created_on = moment()
          this.gpath_career_interObjList.unshift(gpathCareerInterAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelGPathCareerInterAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closegpath_career_interAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareerInterEditModal
     */
    closeGPathCareerInterEditModal () {
      try {
        this.showModelGPathCareerInterEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeGPathCareerInterEditModal() and Exception:", err.message)
      }
    },
    /**
     * gpaths product Id List Get
    */
    async gpathsproductIdListGet () {
      try {
        const gpaList = await GPathConfig.gpcList(this, this.whereFilter)
        if (!gpaList.resp_status) {
          ApiResponse.responseMessageDisplay(this, gpaList)
          return
        }
        this.assessmentObjList = gpaList.resp_data.data
        this.gpcPdtIdList = this.assessmentObjList.map(gpc => ({
          id: gpc.gpc_pdt_id
        }))
      }
      catch (err) {
        console.error("Exception in gpathsproductIdListGet() and err: ", err.message)
      }
    }
  }
}
</script>
